import {
  getStudyQueryStudiesStudyIdQueriesStudyQueryIdGet,
  GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import studyQueryKeys from './queryKeyFactory'
import { AxiosError } from 'axios'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

type UseStudyQueryDetailsParams = {
  studyId: string
  queryId: string
}

interface UseStudyQueryDetailsOptions {
  enabled?: boolean
}

export function useStudyQueryDetails(
  params: UseStudyQueryDetailsParams,
  options: UseStudyQueryDetailsOptions = {},
): UseQueryResult<GetStudyQueryStudiesStudyIdQueriesStudyQueryIdGetResponse, AxiosError<HTTPValidationError>> {
  const { studyId, queryId } = params

  return useQuery({
    queryKey: studyQueryKeys.detail(studyId, queryId),
    queryFn: async () => {
      if (!queryId) {
        throw new Error('queryId is required to fetch study query details.')
      }
      const response = await getStudyQueryStudiesStudyIdQueriesStudyQueryIdGet({
        path: { study_id: studyId, study_query_id: queryId },
        throwOnError: true,
      })
      return response.data
    },
    enabled: (options.enabled ?? true) && !!queryId,
  })
}
